import React from 'react';
import { Container, Table } from 'react-bootstrap';
import { isUndefined, isNull } from 'lodash';

import HeaderSecondary from '@components/HeaderSecondary';
import { BackButton, CopyLinkButton, Loading, LoadingError } from '@components/Base';

import { useCarQuotesFetch } from './hook';
import { TableInsurer } from './table-insurer';
import { TablePremium } from './table-premium';
import { TableCover } from './table-cover';
import { TableDeductible } from './table-deductible';
import { TableExclusion } from './table-exclusion';

const CarQuoteComparePage = () => {
  const carQuotes = useCarQuotesFetch();

  if (isUndefined(carQuotes)) return <Loading />;
  if (isNull(carQuotes)) return <LoadingError />;

  return (
    <>
      <HeaderSecondary />

      <Container className="mt-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <BackButton />
          <CopyLinkButton />
        </div>

        <Table>
          <tbody>
            <TableInsurer />
            <TablePremium />
            <TableCover />
            <TableDeductible />
            <TableExclusion />
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export { CarQuoteComparePage };
